import { RouteLocationNormalized, Router } from 'vue-router'
import { Store } from 'vuex'
import { RootState } from '@/store'
import { RemoteLog } from '@/modules/common/utils/loggingUtils'

// The pattern, not the path: a path can carry a kit identifier, and the pattern counts each page once.
function pageOf(route: Pick<RouteLocationNormalized, 'matched'>): string | undefined {
	return route.matched[route.matched.length - 1]?.path
}

export function registerPageViewLog(router: Router, store: Store<RootState>): void {
	router.afterEach((to, from, failure) => {
		if (failure) {
			return
		}

		const { isLoggedIn, user } = store.state.auth

		RemoteLog.setPage(pageOf(to))
		RemoteLog.usage({
			message: 'Page viewed',
			context: {
				route: to.name?.toString(),
				from_page: pageOf(from),
				redirected_from: to.redirectedFrom === undefined ? undefined : pageOf(to.redirectedFrom),
				logged_in: isLoggedIn,
				authorized_user: user?.has_authorized_user_role === true,
				viewport_width: window.innerWidth,
			},
		})
	})
}
